import { type JSX } from 'solid-js';

interface ResultCellProps {
  label: string;
  value: string;
  testId?: string;
  valueTestId?: string;
}

export const ResultCell = (props: ResultCellProps): JSX.Element => {
  return (
    <div class="flex flex-col flex-1 text-center" data-testid={props.testId}>
      <div class="text-xs text-gray-6 mb-1">{props.label}</div>
      <div
        class="text-sm text-gray-10 font-semibold"
        data-testid={props.valueTestId}
        data-mask-screenshot
      >
        {props.value}
      </div>
    </div>
  );
};
